import type { GateCohortCode, PdrGateObligation } from "@/types";

export function isGateCohort(cohortCode: string | null | undefined): cohortCode is GateCohortCode {
  return cohortCode === "LM" || cohortCode === "RI";
}

export function getGateEligibilityLabel(cohortCode: GateCohortCode): string {
  return cohortCode === "LM" ? "Limited Classification Transfer Eligibility" : "Reinstatement eligibility";
}

export function getGateEligibilitySubtext(cohortCode: GateCohortCode, satisfied: boolean): string {
  if (cohortCode === "LM") {
    return satisfied
      ? "Member has satisfied the remaining PDR requirements and may transfer to an active classification"
      : "Member must satisfy the remaining PDR requirements before transferring to an active classification";
  }

  return satisfied
    ? "Member has satisfied the remaining PDR requirements and may be eligible to reinstate"
    : "Member must satisfy the remaining PDR requirements before being eligible to reinstate";
}

export function getGateStatusLabel(cohortCode: GateCohortCode, satisfied: boolean): string {
  if (cohortCode === "LM") {
    return "No Requirements";
  }

  return satisfied ? "No Requirements" : "Not Eligible to Reinstate";
}

export function resolveGateCohortCode(
  cohortCode: string | null | undefined,
  gateObligation?: PdrGateObligation | null
): GateCohortCode | undefined {
  if (isGateCohort(cohortCode)) {
    return cohortCode;
  }

  if (gateObligation && isGateCohort(gateObligation.cohortCode)) {
    return gateObligation.cohortCode;
  }

  return undefined;
}

export function resolveGateSatisfied(args: {
  status?: string | null;
  gateObligation?: PdrGateObligation | null;
}): boolean {
  if (args.gateObligation != null) {
    return args.gateObligation.satisfied;
  }

  return args.status?.toLowerCase() === "requirements_met";
}

export function isGateRequirementsView(
  cohortCode: string | null | undefined,
  gateObligation?: PdrGateObligation | null
): boolean {
  return resolveGateCohortCode(cohortCode, gateObligation) != null;
}
